import { ProgressStepType, ProgressStepEnum } from "../../../redux/slices/progressBarSlice";
import { ProgressStep } from "../../atoms/ProgressStep";
import "./ProgressBar.scss";

interface Props {
  steps: Record<ProgressStepEnum, ProgressStepType>;
}

const ProgressBar: React.FC<Props> = (props: Props) => {
  const steps = Object.entries(props.steps);

  return (
    <div role="progressbar" className="progress-bar" aria-label="progress bar">
      {steps.map(([stepEnum, step], index) => (
        <ProgressStep
          key={stepEnum}
          percentage={step.percentage}
          label={step.label}
          isLastStep={index + 1 >= steps.length}
        />
      ))}
    </div>
  );
};

export default ProgressBar;
